import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { HelpHint } from "../misc/HelpHint";
import { useFontPreference } from "./useFontPreference";

export const FontPreference = () => {
  const [font, setFont] = useFontPreference();
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <label htmlFor="interface-font" className="text-sm font-medium">
          Шрифт интерфейса
        </label>
        <HelpHint>
          Выбор применяется сразу и сохраняется для вашего аккаунта в этом
          браузере.
        </HelpHint>
      </div>
      <Select
        value={font}
        onValueChange={(value) =>
          setFont(value === "inter" ? "inter" : "rovero")
        }
      >
        <SelectTrigger id="interface-font" className="w-full">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="inter">Inter</SelectItem>
          <SelectItem value="rovero">ROVERO Display</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
